// Этот use нужен для vue-draggable. Делает переноску в стиле notion (линией)
// Пример использования смотри в components/Properties/PropertyFilter.vue

/**
 * @typedef useDraggableOptions
 * @property {'after'|'before'} pseudo="before" Используется, чтобы поменять псевдо-селектор для создания линии
 * @property {boolean} onlyStyles=true Используется, если хотим менять только стили по евентам
 */
/**
 * @param {import('vue').Ref<any[]>} list Сортируемы массив (прям ссылка на него)
 * @param {number} gap Расстояние между элементами в списке в пикселях
 * @param {useDraggableOptions} options
 */
const useDraggable = (
  list,
  gap = 0,
  options = { onlyStyles: false, pseudo: "before" }
) => {
  let persistentClone = null;
  let style = null;

  const onDraggableStart = e => {
    const el = e.item;
    let index = e.oldIndex;
    if (index < 0) {
      index = 0;
    }
    persistentClone = e.from.insertBefore(
      el.cloneNode(true),
      e.from.children[index]
    );

    el.classList.add("transform-line");
    insertStyle();
  };

  const onDraggableEnd = e => {
    persistentClone.remove();
    persistentClone = null;

    e.item.classList.remove("transform-line");
    removeStyle();

    if (options.onlyStyles) {
      return;
    }

    if (e.newIndex > e.oldIndex) {
      const el = list.value.splice(e.newIndex, 1);

      if (el.length) {
        list.value.splice(e.newIndex - 1, 0, el[0]);
      }
    }
  };

  const insertStyle = () => {
    style = document.createElement("style");
    style.innerHTML = `
      .transform-line {
        visibility: hidden;
        height: 0;
        position: relative;
        margin: ${-gap / 2}px 0 !important;
        padding: 0 !important;
      }
      
      .transform-line::${options.pseudo} {
        content: '';
        visibility: visible;
        border-radius: 2px;
        width: 100%;
        height: 4px;
        background: var(--v-info-base);
        position: absolute;
        top: -2px;
        left: 0;
      }
    `;
    document.head.appendChild(style);
  };

  const removeStyle = () => {
    style.remove();
  };

  return {
    onDraggableStart,
    onDraggableEnd
  };
};

export { useDraggable };
